import React, {FC, useEffect, useMemo} from "react";
import Heading from "components/Heading/Heading";
import Glide from "@glidejs/glide";
import NextPrev from "shared/NextPrev/NextPrev";
import useNcId from "hooks/useNcId";
import StoryCard from "components/StoryCard/StoryCard";
import {StoryType} from "data/types";

export interface SectionSliderStoriesProps {
  className?: string;
  itemClassName?: string;
  heading?: string;
  subHeading?: string;
  stories: StoryType[];
  itemPerRow?: 4 | 5;
  sliderStyle?: "style1" | "style2";
  uniqueClassName: string;
}

const SectionSliderStories: FC<SectionSliderStoriesProps> = ({
  heading = "",
  subHeading = "",
  className = "",
  itemClassName = "",
  stories,
  itemPerRow = 5,
  sliderStyle = "style2",
  uniqueClassName,
}) => {
  const UNIQUE_CLASS =
    "SectionSliderNewCategories__" + uniqueClassName + useNcId();

  let MY_GLIDEJS = useMemo(() => {
    return new Glide(`.${UNIQUE_CLASS}`, {
      perView: itemPerRow,
      gap: 32,
      bound: true,
      breakpoints: {
        1280: {
          perView: itemPerRow - 1,
        },
        1024: {
          gap: 20,
          perView: itemPerRow - 1,
        },
        768: {
          gap: 20,
          perView: itemPerRow - 2,
        },
        640: {
          gap: 20,
          perView: itemPerRow - 3,
        },
        500: {
          gap: 20,
          perView: 1.3,
        },
      },
    });
  }, [UNIQUE_CLASS]);

  useEffect(() => {
    setTimeout(() => {
      MY_GLIDEJS.mount();
    }, 100);
  }, [MY_GLIDEJS, UNIQUE_CLASS]);

  return (
    <div className={`nc-SectionSliderNewCategories ${className}`}>
      <div className={`${UNIQUE_CLASS} flow-root`}>
        <Heading
          desc={subHeading}
          hasNextPrev={sliderStyle === "style1"}
          isCenter={sliderStyle === "style2"}
        >
          {heading}
        </Heading>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {stories.map((item, index) => (
              <li key={index} className={`glide__slide ${itemClassName}`}>
                <StoryCard story={item} stories={stories} />
              </li>
            ))}
          </ul>
        </div>

        {sliderStyle === "style2" && stories.length > itemPerRow && (
          <NextPrev className="justify-center mt-6" />
        )}
      </div>
    </div>
  );
};

export default SectionSliderStories;
